/* eslint-disable react/no-danger */
import type { FC } from 'react'
import cn from 'classnames'
import type { ProductDescriptionProps } from '.'
import s from './product-description.module.css'

const ProductDescription: FC<ProductDescriptionProps> = ({ className, title, description }) => {
  // const [text, setText] = useState<string>('')
  // const [toggle, setToggle] = useState<boolean>(false)

  // useEffect(() => {
  //   setText(ssr === false && description.length >= crop ? `${description.slice(0, crop)}...` : description)
  //   setToggle(description.length >= crop)
  // }, [description, crop, ssr])

  // const isCroped = useMemo(() => {
  //   return text.length < description.length
  // }, [text, description])

  // function toggleDescription() {
  //   setText(isCroped ? description : description.slice(0, crop))
  // }

  return (
    <article className={cn(s.root, className)}>
      {title && <div className={s.title}>{title}</div>}
      <div dangerouslySetInnerHTML={{ __html: description }} />
      {/* {!ssr && toggle ? (
        <button type="button" onClick={toggleDescription} className={s.button}>
          {isCroped ? 'mostrar mais' : 'mostrar menos'}
        </button>
      ) : null} */}
    </article>
  )
}

export default ProductDescription
